import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import httpRequest from "../../utils/httpRequest";
import { BASE_URL } from "../../config/settings";

const initialState = {
    reports: [],
    loading: false,
    error: null,
    attendanceReports: [],
    attendanceLoading: false,
    attendanceError: null,
};


export const genReports = createAsyncThunk("reports/genReports", async (arg, { rejectWithValue }) => {
    try {
     const response = await httpRequest(`${BASE_URL}/Report/FilterReport`,
      "post",
      arg ,
      null,
      "multipart/form-data",
      );
    //   console.log("genReports", response);
     if (response?.response?.data) {
         throw response;
     }
      return response;
     
    } catch (error) {
     console.log("error: ",error?.response?.data);
     return rejectWithValue(error?.response?.data);
    }
 });

export const fetchAttendanceReport = createAsyncThunk(
  "reports/fetchAttendanceReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/Report/GetAttendanceReport`,
        "post",
        payload
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      console.log("fetchAttendanceReport error: ", error?.response?.data || error);
      return rejectWithValue(error?.response?.data || error?.message || "Failed to fetch attendance report");
    }
  }
);

const reportsSlice = createSlice({
    name: "reports",
    initialState,
    reducers: {
        clearAttendanceReports: (state) => {
            state.attendanceReports = [];
            state.attendanceError = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(genReports.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(genReports.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.reports = payload;
            state.error = null;
        });

        builder.addCase(genReports.rejected, (state, {payload}) => {
            state.loading = false;
            state.reports = [];
            state.error = payload;
        });

        builder.addCase(fetchAttendanceReport.pending, (state) => {
            state.attendanceLoading = true;
            state.attendanceError = null;
        });

        builder.addCase(fetchAttendanceReport.fulfilled, (state, {payload}) => {
            state.attendanceLoading = false;
            state.attendanceReports = payload;
            state.attendanceError = null;
        });

        builder.addCase(fetchAttendanceReport.rejected, (state, {payload}) => {
            state.attendanceLoading = false;
            state.attendanceReports = [];
            state.attendanceError = payload;
        });
    },
});


export const { clearAttendanceReports } = reportsSlice.actions;
export default reportsSlice.reducer;